import {getDataWithPromise, getParamList, Globals, handleAjaxError} from "./BaseDataFns";

export const createUser = ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/iros' ;

    // Legacy structures
    const postData = { socialworker: data } ;

    getDataWithPromise ( url, 'POST', postData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getUserData = ( role_id, onComplete ) =>
{
    const filter = role_id != 0 ? '?roleid=' + role_id : '' ;

    const url = Globals.APIFolder + '/users' + filter ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getUserDetails = ( user_id, params, onComplete ) =>
{
    const paramList = getParamList( params, '?') ;

    const url = Globals.APIFolder + '/users/' + user_id + paramList ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getUserTypes = async () =>
{
    const url = Globals.APIFolder + '/users/types'  ;

    return getDataWithPromise ( url, 'GET', {}) ;
}

export const updateUserDetails = ( user_id, operation, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/users2/' + user_id ;

    getDataWithPromise ( url, 'PUT', { operation: operation, data: data } )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const createUserModal = ( user_type, data, onComplete ) =>
{
    let url = Globals.APIFolder + '/users/new/' + user_type  ;

    // Legacy form post requirement
    data.user.usertype = user_type ;

    const postData = data.user ;

    getDataWithPromise ( url, 'POST', postData )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}


export const createESWUser = ( data, onComplete ) =>
{
   const url = Globals.APIFolder + '/esws' ;

   const postData = { esw: data } ;

   getDataWithPromise ( url, 'POST', postData )
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}

export const deleteUser = ( user_id, user_type, onComplete ) =>
{
    const url = Globals.APIFolder + '/iros/' + user_id ;

    const postData = { user_id : user_id, user_type: user_type } ;

    getDataWithPromise ( url, 'DELETE', postData )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}


export const requestUserPasswordReset = ( user_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/users/'+user_id+'/resetpassword';

    getDataWithPromise ( url, 'PUT', {} )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}
